import { brandColorTokens as colors } from "./brandColorTokens";

/** Shared surfaces for dialogs and the non-blocking update notification. */
export const productDialogSurfaceStyles = {
  backgroundColor: colors.facilitatorMainContentPaper,
  color: colors.bodyText,
  borderColor: colors.surfaceBorder,
  borderRadius: "var(--mantine-radius-lg)",
  boxShadow: "var(--mantine-shadow-xl)",
};
export const productDialogTitleStyles = {
  color: colors.facilitatorPageHeading,
  fontSize: "var(--mantine-h2-font-size)",
  lineHeight: "var(--mantine-h2-line-height)",
  fontWeight: 700,
};
export const productDialogOverlayProps = {
  backgroundOpacity: 0,
  style: { backgroundColor: colors.scrimOnLight, backdropFilter: "blur(1px)" },
};
